const DEFAULT_DATA = {
  hero: {
    badge: 'ISO 27001 UYUMLU',
    badge_en: 'ISO 27001 COMPLIANT',
    title: 'Ağ Altyapısı Güvenliği',
    title_en: 'Network Infrastructure Security',
    description:
      'Yönlendiriciler, anahtarlar ve güvenlik duvarları dahil tüm ağ varlıklarınızı tek bir platformdan ISO 27001 standartlarına uygun şekilde yönetin.',
    description_en:
      'Manage all your network assets including routers, switches, and firewalls from a single platform in compliance with ISO 27001 standards.',
    primaryButtonText: 'Hemen Başla',
    primaryButtonText_en: 'Get Started',
    secondaryButtonText: 'Demo İzle',
    secondaryButtonText_en: 'Watch Demo',
    image: null,
  },

  statsSection: {
    stats: [
      {
        title: 'Uyumluluk',
        title_en: 'Compliance',
        value: '%100',
        value_en: '100%',
        small: 'Hedefin Üzerinde',
        small_en: 'Above Target',
      },
    ],
  },

  features: {
    Title: 'Öne Çıkan Özellikler',
    Title_en: 'Featured Capabilities',
    Description:
      'Ağ cihazlarınız için görünürlük, izleme, erişim kontrolü ve olay takibi sağlayan temel güvenlik yetenekleri.',
    Description_en:
      'Core security capabilities that provide visibility, monitoring, access control, and incident tracking for your network devices.',
    cards: [
      {
        icon: 'FaNetworkWired',
        title: 'Ağ Varlık Envanteri',
        title_en: 'Network Asset Inventory',
        description:
          'Tüm yönlendiriciler ve anahtarların otomatik envanterini tutun. Manuel takip hatalarını ortadan kaldırın.',
        description_en:
          'Automatically maintain inventory of all routers and switches. Eliminate manual tracking errors.',
        bullets: [],
      },
      {
        icon: 'FaShieldAlt',
        title: 'Zafiyet Yönetimi',
        title_en: 'Vulnerability Management',
        description:
          'Ağ donanımlarındaki zafiyetleri ISO 27001 gerekliliklerine göre tarayın, önceliklendirin ve kapatma sürecini yönetin.',
        description_en:
          'Scan, prioritize, and manage the remediation of vulnerabilities in network hardware according to ISO 27001 requirements.',
        bullets: [],
      },
      {
        icon: 'FaUserLock',
        title: 'Erişim Kuralları',
        title_en: 'Access Rules',
        description:
          'Güvenlik duvarı kurallarını ve ağ erişim listelerini merkezi olarak denetleyin ve optimize edin.',
        description_en:
          'Centrally audit and optimize firewall rules and network access lists.',
        bullets: [],
      },
    ],
  },

  deviceTypes: {
    title: 'Yönetilen Cihaz Türleri',
    title_en: 'Managed Device Types',
    cards: [
      {
        icon: 'FaRouter',
        label: 'Yönlendiriciler',
        label_en: 'Routers',
        description: 'Konfigürasyon takibi ve yedekleme.',
        description_en: 'Configuration tracking and backup.',
      },
      {
        icon: 'FaExchangeAlt',
        label: 'Anahtarlar',
        label_en: 'Switches',
        description: 'Switch port güvenliği ve VLAN yönetimi.',
        description_en: 'Switch port security and VLAN management.',
      },
      {
        icon: 'FaShieldVirus',
        label: 'Güvenlik Duvarları',
        label_en: 'Firewalls',
        description: 'Politika analizi ve kural denetimi.',
        description_en: 'Policy analysis and rule auditing.',
      },
    ],
  },

  cta: {
    Title: 'Ağ güvenliğinizi bugün güçlendirin.',
    Title_en: 'Strengthen your network security today.',
    Description:
      'ISO 27001 uyumluluk yolculuğunuzda ağ altyapınızı güvence altına alıyoruz.',
    Description_en:
      'We secure your network infrastructure throughout your ISO 27001 compliance journey.',
    primaryButtonText: 'Ücretsiz Dene',
    primaryButtonText_en: 'Try for Free',
  },
};

export default DEFAULT_DATA;